import { LoadingMask } from '@/components/common/LoadingMask'

import styles from './CardModalLoading.module.scss'

export const CardModalLoading = () => (
  <div className={styles.container}>
    <LoadingMask bgNone blurNone loading showShimmer={false} showSpinner />
  </div>
)
